import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch } from "react-router-dom";

import { getApi } from "../../api/api";
import { setCity, selectCity } from "../../store/slices/citySlice";
import { getFromStorage } from "../utils/functions/localStorage";
import { CityInterface } from "../types/interfaces";

export const useCity = () => {
  const dispatch = useDispatch();
  const selectedCity = useSelector(selectCity);
  const [hydrated, setHydrated] = useState(false);

  const cityMatch = useMatch("/city/:id");
  const cityIdFromPath = cityMatch?.params.id;

  useEffect(() => {
    const hydrate = async () => {
      if (cityIdFromPath) {
        try {
          const cities = await getApi().getCities();
          const fromUrl = cities.find((c) => String(c.id) === cityIdFromPath);
          if (fromUrl) {
            dispatch(setCity(fromUrl));
            setHydrated(true);
            return;
          }
        } catch {
          // fallback
        }
      }

      const stored = getFromStorage<CityInterface>("selectedCity");
      if (stored !== null && stored.id !== undefined) {
        dispatch(setCity(stored));
      }

      setHydrated(true);
    };

    hydrate();
  }, [dispatch, cityIdFromPath]);

  return { hydrated, selectedCity };
};
